import type { DateTime } from 'luxon'

import { getRelativeTimeShort } from '@/utils/time'

import useIntervalValue from './useIntervalValue'

const REFRESH_INTERVAL_SECONDS = 10

export default function useRelativeTimeShort({
  time,
  timeIsInFuture = false,
}: {
  time: DateTime
  timeIsInFuture?: boolean
}): string {
  return useIntervalValue(
    () => getRelativeTimeShort({ time, timeIsInFuture }),
    REFRESH_INTERVAL_SECONDS * 1000,
    [time],
    {
      immediate: true,
    }
  )
}
